import React from 'react';

import styles from './LegendItem.module.scss';

const LegendItem = ({ color = 'currentColor', Tag = 'div', children, ...props }) => (
  <Tag {...props}>
    <span
      className={styles.square}
      style={{ backgroundColor: color }}
    />
    {children}
  </Tag>
);

export default LegendItem;
